module.exports = __webpack_public_path__ + "static/media/pigment-wall-update.692aaafb.png";